// Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { ERC20 } from '@typechain-types/index'
import { ethers, Contract } from 'ethers'
import { Erc20Abi } from './Abis'
import { ChainConfiguration } from './DeploymentConfigs'
import { EthAddr } from './SchemaTypes'
import { ERC20Wei } from './conversions'

export type LiquidityAsset = {
  chainConfigName: string
  name: string
  symbol: string
  addr: EthAddr
  decimals: number
}

export type ChainAccountValues = Record<EthAddr, ERC20Wei>
export async function getLiquidityAssetForAddress(
  assetAddr: EthAddr,
  chainConfiguration: ChainConfiguration
): Promise<LiquidityAsset> {
  const provider = new ethers.JsonRpcProvider(chainConfiguration.backendProviderUrl, undefined, { staticNetwork: true })

  const erc20Contract = new Contract(assetAddr, Erc20Abi, provider) as unknown as ERC20
  const name = await erc20Contract.name()
  const symbol = await erc20Contract.symbol()
  const decimals = Number(await erc20Contract.decimals())
  return { chainConfigName: chainConfiguration.chainConfigurationName, name, symbol, decimals, addr: assetAddr }
}
